import { handleKeyDown } from "_services";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { constant } from 'constants/constant';
import React, { useState } from "react";

const AddExpenseServiceModal = (props) => {
    const { closeModal, onSubmitExpense, expenseType = "Expenses", is_gst, expenseCategoryList, gstTypeList } = props;

    const initial = {
        category: "",
        item_type: "Goods", // Goods or Services
        hsn_code: "",
        description: "",
        tax: 0,
        amount: 0,
        type: expenseType,// Parts, Services, or Expenses,
        tax_amount: 0
    };

    const [form, setForm] = useState(initial);
    const [formError, setFormError] = useState({});

    // Sample expense categories based on type
    const expenseCategories = {
        Parts: [
            { label: "Engine Parts", value: "Engine Parts" },
            { label: "Brake Parts", value: "Brake Parts" },
            { label: "Suspension Parts", value: "Suspension Parts" },
            { label: "Electrical Parts", value: "Electrical Parts" },
            { label: "Tire & Wheels", value: "Tire & Wheels" },
        ],
        Services: [
            { label: "Oil Change", value: "Oil Change" },
            { label: "Greasing Charges", value: "Greasing Charges" },
            { label: "Brake Service", value: "Brake Service" },
            { label: "Engine Tune-up", value: "Engine Tune-up" },
            { label: "Alignment", value: "Alignment" },
        ],
        Expenses: expenseCategoryList
    };

    // Tax percentage options


    const handleOnChange = (name, value) => {
        setForm(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error for this field
        if (formError[name]) {
            setFormError(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const validateForm = () => {
        const errors = {};

        if (!form.category) {
            errors.category = "Please select expense category";
        }

        if (!form.amount || form.amount <= 0) {
            errors.amount = "Please enter valid amount";
        }
        if (is_gst) {
            if (!form.tax) {
                errors.tax = "Please enter valid Tax";
            }

        }
        setFormError(errors);
        return Object.keys(errors).length === 0;
    };

    const handleSubmit = () => {
        if (validateForm()) {
            if (validateForm()) {
                const hasGST = form.gst_type !== 1; // check GST type

                const expenseData = {
                    id: Date.now(),
                    category: form.category,
                    item_type: form.item_type,
                    hsn_code: form.hsn_code,
                    description: form.description,
                    tax: hasGST ? form?.tax || 0 : 0, // disable tax if without GST
                    // amount: hasGST
                    //     ? Number(form.amount) + (Number(form.amount) * Number(form.tax.value || 0)) / 100
                    //     : Number(form.amount), // GST logic
                    tax_amount: hasGST
                        ? (Number(form.amount) * Number(form.tax.value || 0)) / 100
                        : 0, // GST logic
                    amount: Number(form?.amount),
                    type: form.type,
                    qty: 1, // Default quantity
                    rate: Number(form.amount),
                    discount: 0
                };
                onSubmitExpense(expenseData);

            }
            closeModal();
            setForm(initial); // Reset form
        }
    };

    const modalProps = {
        ...props,
        onSubmit: handleSubmit
    };

    return (
        <CommonModal {...modalProps}>
            <div className="addExpense_modal_body" style={{ padding: '20px' }}>
                {/* Expense Category Dropdown */}
                <div style={{ marginBottom: is_gst == 1 ? '0px' : "20px" }}>
                    <CustomSelect
                        label="Expense Category"
                        placeholder="Select Category"
                        options={expenseCategories[expenseType] || expenseCategories.Expenses}
                        value={form.category || null}
                        onSelect={(data) => handleOnChange("category", data)}
                        error={formError.category}
                        focus={!!formError.category}
                    />
                </div>

                {/* Goods/Services Radio Buttons */}
                {is_gst == 1 && <div className="checkBx_lv" style={{ marginBottom: '20px' }}>
                    {constant.expenseCategory?.map((item, index) => (
                        <div className="_dualCheckr_bx" key={index} style={{ maxWidth: '140px', width: '100%' }}>
                            <input
                                style={{ marginTop: '2px' }}
                                className="form-check-input"
                                id={`item_type_${item?.value}`}
                                type="radio"
                                name="item_type"
                                checked={form.item_type === item?.value}
                                value={item?.value}
                                onChange={({ target: { value } }) => handleOnChange("item_type", value)}
                            />
                            <label
                                style={{ fontSize: '14px' }}
                                htmlFor={`item_type_${item?.value}`}
                                className="form-check-label"
                            >
                                {item.label}
                            </label>
                        </div>
                    ))}
                </div>}

                {/* HSN Code */}
                {is_gst == 1 && <div style={{ marginBottom: '20px' }}>
                    <CommonInput
                        label="HSN code"
                        type="text"
                        placeholder="HSN code"
                        name="hsn_code"
                        value={form.hsn_code}
                        onChange={({ target: { value } }) => {
                            // allow only numbers
                            if (!/^\d*$/.test(value)) return;

                            // max 6 digits
                            if (value.length > 6) return;

                            handleOnChange("hsn_code", value);
                        }}
                        maxLength={6}
                    />
                </div>}

                {/* Item Description */}
                <div style={{ marginBottom: '20px' }}>
                    <CommonInput
                        label="Item Description"
                        type="text"
                        placeholder="Item Description"
                        name="description"
                        value={form.description}
                        onChange={({ target: { value } }) => handleOnChange("description", value)}
                        error={formError.description}
                        focus={!!formError.description}
                        maxLength={200}
                    />
                </div>

                {/* Tax % */}
                {is_gst == 1 && <div style={{ marginBottom: '20px' }}>
                    <CustomSelect
                        label="Tax %"
                        placeholder="Select Tax %"
                        options={gstTypeList}
                        value={form.tax || null}
                        onSelect={(data) => handleOnChange("tax", data)}
                        error={formError.tax}
                        focus={!!formError.tax}
                    />
                </div>}

                {/* Amount */}
                <div style={{ marginBottom: '20px' }}>
                    <CommonInput
                        label="Amount"
                        type="text"
                        placeholder="Amount"
                        name="amount"
                        value={form.amount || ""}
                        // onChange={({ target: { value } }) => handleOnChange("amount", value)}
                        onChange={({ target: { name, value } }) => {
                            if (/^0[0-9]/.test(value)) {
                                value = value.replace(/^0+/, ''); // "01" → "1"
                            }

                            // Allow "0." for decimals but not "0x" where x is digit
                            if (value === "0") {
                                handleOnChange("amount", value)
                                return;
                            }
                            handleOnChange("amount", value)
                        }}
                        error={formError.amount}
                        focus={!!formError.amount}
                        // min="0"
                        // step="0.01"
                        maxLength={10}
                        onKeyDown={handleKeyDown}
                    />
                </div>
            </div>
        </CommonModal>
    );
};

export default AddExpenseServiceModal;